export const RECEIVE_ES_DATA = 'ESProvider/RECEIVE_ES_DATA';
export const REQUEST_ES_DATA = 'ESProvider/REQUEST_ES_DATA';
export const INVALIDATE_ES_DATA  = 'ESProvider/INVALIDATE_ES_DATA';
export const RESET_ES_DATA  = 'ESProvider/RESET_ES_DATA';
export const CLEAR_ITEM  = 'ESProvider/CLEAR_ITEM';
